import { render } from "./preview-quotation.vue?vue&type=template&id=58e47907"
import script from "./preview-quotation.vue?vue&type=script&lang=js"
export * from "./preview-quotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__